import { TReduxActions } from '../../types/redux';
import { EFoldersActionTypes } from '../../actions/folders/actions';
import { IFoldersState } from '../../actions/folders/types';
import { IFavoritesFolder } from '../../types/favoriteEntity';
import { getTextCount } from '../../utils/favoriteEntity';

export const foldersInitialState = {
  list: [],
  folderCount: 0,
  selectedId: null,
  modalRenameIsOpen: false,
  modalRemoveIsOpen: false,
  canLoadMore: false,
};

export const foldersReducer = (state: IFoldersState = foldersInitialState, action: TReduxActions): IFoldersState => {
  switch (action.type) {
    case EFoldersActionTypes.Add:
      const newFolder: IFavoritesFolder = {
        id: action.payload.id,
        clientId: 0,
        name: action.payload.name,
        description: getTextCount(0),
        imageUrl: '',
        offersCount: 0,
      };

      const newList = state.list.map(item => ({ ...item }));
      newList.unshift(newFolder);

      return {
        ...state,
        list: newList,
      };

    case EFoldersActionTypes.Set:
      return {
        ...state,
        list: action.payload.folders,
      };

    case EFoldersActionTypes.Select:
      return {
        ...state,
        selectedId: action.payload.folder ? action.payload.folder.id : null,
        list: state.list.map(item => ({ ...item })),
      };

    case EFoldersActionTypes.OpenModalRename:
      return {
        ...state,
        list: state.list.map(item => ({ ...item })),
        modalRenameIsOpen: true,
      };

    case EFoldersActionTypes.OpenModalRemove:
      return {
        ...state,
        list: state.list.map(item => ({ ...item })),
        modalRemoveIsOpen: true,
      };

    case EFoldersActionTypes.CloseModalRename:
      return {
        ...state,
        list: state.list.map(item => ({ ...item })),
        modalRenameIsOpen: false,
      };

    case EFoldersActionTypes.CloseModalRemove:
      return {
        ...state,
        list: state.list.map(item => ({ ...item })),
        modalRemoveIsOpen: false,
      };

    case EFoldersActionTypes.Remove:
      return {
        ...state,
        list: state.list.filter(item => item.id !== action.payload.id),
      };

    case EFoldersActionTypes.Rename:
      return {
        ...state,
        list: state.list.map(item =>
          item.id === action.payload.id
            ? {
                ...item,
                name: action.payload.name,
              }
            : item,
        ),
      };

    case EFoldersActionTypes.SetCanLoadMore:
      return {
        ...state,
        canLoadMore: action.payload.value,
      };

    default:
      return state;
  }
};
